/**
 * jQuery plugin to store/restore form-state as an object.
 *
 * This does not deal with encoding/decoding in JSON or any
 * other data-format, nor does it deal with storage-media.
 *
 * Minifies to < 1KB.
 *
 * To obtain the state of form elements:
 * 
 *   var state = $('form').formstate();
 *
 * To obtain the state of certain form elements:
 *
 *   var state = $('form').formstate(':visible');
 *
 * To restore state to form elements:
 *
 *   $('form').formstate(state);
 *
 * To restore state to certain form elements:
 *
 *   $('form :input:visible').formstate(state);
 *
 * @author Rasmus Schultz <http://blog.mindplay.dk>
 */
(function ($) {

	var
		excluded_type = ':button,:submit,:reset,:password',
		input_types = 'input,select,textarea';

	function get_state($inputs) {
		var data = {};

		$inputs.each(function () {
			var $input = $(this);

			if ($input.is(excluded_type)) {
				return;
			}

			if ($input.is(':checkbox')) {
				var list = data[$input.attr('name')] || [],
					value = $input.attr('value');
				if ($input.prop('checked')) {
					list.push(value);
				}
				data[$input.attr('name')] = list;
			} else if ($input.is(':radio')) {
				if ($input.prop('checked')) {
					data[$input.attr('name')] = $input.attr('value');
				}
			} else {
				data[$input.attr('name')] = $input.val();
			}
		});

		return data;
	}

	function set_state($inputs, data) {
		$inputs.each(function () {
			var $input = $(this);

			if ($input.is(excluded_type)) {
				return;
			}

			if ($input.is(':checkbox')) {
				$input.prop('checked', (data[$input.attr('name')] || []).indexOf($input.attr('value')) != -1);
			} else if ($input.is(':radio')) {
				$input.prop('checked', data[$input.attr('name')] === $input.attr('value'));
			} else {
				$input.val(data[$input.attr('name')]);
			}
		});
	}

	$.fn.formstate = function (a) {
		var $inputs = (this.is('form') ? this.find(input_types) : this.filter(input_types))
			.filter('[name]');

		if (!a) {
			return get_state($inputs);
		} else if ($.type(a) === 'string') {
			return get_state($inputs.filter(a));
		} else {
			set_state($inputs, a);
		}

		return this;
	};

})(jQuery);

var search = {



	active: false,



	loaded: false,



	url: null,

	request: null,



	lastSearchTerm: '',



	stickyInstance: false,



	loading: {

		timeout: null,

		wait: 0,

		start: false,

		end: false

	},



	templates: {

		count: null,

		filters: null,

		appliedFilters: null,

		resultsList: null,

		results: null,

		paginationPrev: null,

		paginationNext: null,

		noResults: null,

		error: null

	},



	preInit: function () {

		// set url

		search.url = '/' + site.html.attr('lang') + '/api/search/jobs/';

		// scroll to job

		if (location.hash) {

			if ($(location.hash).length) {

				site.scrollTo($(location.hash).offset().top);

			}			

		}

		// continue

		search.init(true);

	},



	init: function (pageLoad) {



		$('.js-replace-search:not(.js-replace-search-done)').each(function () {

			var wrapper = $(this);



			var elements = {

				wrapper: wrapper,

				form: wrapper.find('form[data-replace-search="form"]:first'),

				header: wrapper.find('[data-replace-search="header"]'),

				filters: wrapper.find('[data-replace-search="filters"]'),

				filterOptions: wrapper.find('.js-replace-search-filter'),

				appliedFilters: wrapper.find('[data-replace-search="applied-filters"]'),

				count: wrapper.find('[data-replace-search="count"]'),

				loader: wrapper.find('[data-replace-search="loader"]'),

				sort: wrapper.find('[data-replace-search="sort"]'),

				sortOptions: wrapper.find('.js-replace-search-sort'),

				earlyCareers: wrapper.find('.js-replace-search-early-careers'),

				jobs: wrapper.find('[data-replace-search="jobs"]'),

				jobPreviews: wrapper.find('.js-job-preview'),

				results: wrapper.find('[data-replace-search="results"]'),

				noResults: wrapper.find('[data-replace-search="no-results"]'),

				pagination: wrapper.find('[data-replace-search="pagination-prev"], [data-replace-search="pagination-next"]'),

				paginationPrev: wrapper.find('[data-replace-search="pagination-prev"]'),

				paginationPrevButton: wrapper.find('[data-replace-search="pagination-prev-button"]'),

				paginationNext: wrapper.find('[data-replace-search="pagination-next"]'),

				paginationNextButton: wrapper.find('[data-replace-search="pagination-next-button"]'),

				paginationButtons: wrapper.find('[data-replace-search="pagination-prev-button"], [data-replace-search="pagination-next-button"]'),

				searchButtons: wrapper.find('.js-replace-search-submit'),

				searchInput: wrapper.find('.js-replace-search-input'),

				searchLabel: wrapper.find('.js-replace-search-label'),

				clearFilter: wrapper.find('.js-replace-search-filter-clear'),

				clearAllFilters: wrapper.find('.js-replace-search-filter-clear-all')

			};



			var currentPage = elements.form.find('[name="page"]').val();



			var _bindEvents = function () {



				// update elements

				elements.filterOptions = wrapper.find('.js-replace-search-filter');

				elements.sortOptions = wrapper.find('.js-replace-search-sort');

				elements.earlyCareers = wrapper.find('.js-replace-search-early-careers');

				elements.jobPreviews = wrapper.find('.js-job-preview');

				elements.results = wrapper.find('[data-replace-search="results"]');

				elements.pagination = wrapper.find('[data-replace-search="pagination-prev"], [data-replace-search="pagination-next"]');

				elements.paginationPrevButton = wrapper.find('[data-replace-search="pagination-prev-button"]');

				elements.paginationNextButton = wrapper.find('[data-replace-search="pagination-next-button"]');

				elements.paginationButtons = wrapper.find('[data-replace-search="pagination-prev-button"], [data-replace-search="pagination-next-button"]');

				elements.searchButtons = wrapper.find('.js-replace-search-submit');

				elements.searchInput = wrapper.find('.js-replace-search-input');

				elements.searchLabel = wrapper.find('.js-replace-search-label');

				elements.clearFilter = wrapper.find('.js-replace-search-filter-clear');

				elements.clearAllFilters = wrapper.find('.js-replace-search-filter-clear-all');



				// update prev page

				elements.paginationPrevButton.attr('data-page', parseInt(elements.form.find('[name="minpage"]').val(), 10) - 1);



				// update next page

				elements.paginationNextButton.attr('data-page', parseInt(elements.form.find('[name="maxpage"]').val(), 10) + 1);



				// job click

				elements.jobPreviews.not('.js-job-preview-done').each(function () {

					var preview = $(this);



					// clicks

					preview.find('a').off('click').on('click', function () {

						var id = preview.attr('data-results-id');

						var elementId = preview.attr('id');

						var page = preview.attr('data-results-page') || currentPage;



						// update page

						elements.form.find('[name="page"]').val(page);



						// update history

						history.replaceState(elements.form.serialize(), '', '?' + elements.form.serialize() + '#' + elementId);

					});

					// done

					preview.addClass('js-job-preview-done');

				});



				// search click

				elements.searchButtons.off('click').on('click', function () {

					var link = $(this);

					// reset pagination

					_resetPagination();

					// clear filters

					if (link.attr('data-type') != 'undefined' && link.attr('data-type') != 'filter') {

						elements.filterOptions.filter(':checked').removeAttr('checked');

					}

					// scroll

					setTimeout(function () {



						// check if search term has changed, @todo - could potentially be refactored



						if (search.lastSearchTerm !== elements.searchInput.val()) {



							search.lastSearchTerm = elements.searchInput.val();

							elements.sortOptions.filter('[value="Score"]').prop('checked', true);



						}



						// load new results (this has to go in this timeout so the filters have time to be moved back inside the form for serialization)

						search.load(elements, elements.form.serialize(), '', 'pushState');

					}, 300);

					// don't restore seach state

					search.state.should_restore = false;

					// close all pop instances (can only be filters)

					popups.instance.close();

					return false;

				});



				// clear filter click

				elements.clearFilter.off('click').on('click', function () {

					var target = $(this);

					target.closest('.mfp-filters-overlay').find('input[type=checkbox]').prop('checked', false);

					search.displayCount.show(elements);

					return false;

				});



				// clear all click

				elements.clearAllFilters.off('click').on('click', function () {

					// uncheck filters

					elements.filterOptions.filter(':checked').removeAttr('checked');

					// uncheck early careers

					elements.earlyCareers.removeAttr('checked');

					// reset pagination

					_resetPagination();

					// load new results

					search.load(elements, elements.form.serialize(), '', 'pushState');

					return false;

				});



				// sort click

				elements.sortOptions.off('change').on('change', function () {

					var input = $(this);

					// reset pagination

					_resetPagination();

					// load new results

					search.load(elements, elements.form.serialize(), '', 'replaceState');

				});



				// early careers click

				elements.earlyCareers.off('change').on('change', function () {

					var input = $(this);

					// reset pagination

					_resetPagination();

					// load new results

					search.load(elements, elements.form.serialize(), '', 'replaceState');

				});



				// filter options change

				elements.filterOptions.off('change').on('change', function () {

					search.displayCount.show(elements);

				});



				// prev click

				elements.paginationPrevButton.off('click').on('click', function () {

					var link = $(this);

					// show loading anim

					if (link.is('.loading')) return false;

					// set page

					elements.form.find('[name="page"]').val(link.attr('data-page'));

					// update min

					elements.form.find('[name="minpage"]').val(function (i, oldVal) {

						return parseInt(oldVal, 10) - 1;

					});

					// load additional results

					search.load(elements, elements.form.serialize(), 'prepend', 'replaceState');

					return false;

				});



				// next click

				elements.paginationNextButton.off('click').on('click', function () {

					var link = $(this);

					// show loading anim

					if (link.is('.loading')) return false;

					// set page

					elements.form.find('[name="page"]').val(link.attr('data-page'));

					// update max

					elements.form.find('[name="maxpage"]').val(function (i, oldVal) {

						return parseInt(oldVal, 10) + 1;

					});

					// load additional results

					search.load(elements, elements.form.serialize(), 'append', 'pushState');

					return false;

				});



				// input setup



				if (elements.searchInput.val() !== '') { elements.searchLabel.addClass('m-search-block__label--move'); }



				// input focus



				elements.searchInput.off('focus').on('focus', function () {

					elements.searchLabel.addClass('m-search-block__label--move');

				});



				// input blur



				elements.searchInput.off('blur').on('blur', function () {

					if (elements.searchInput.val() == '') { elements.searchLabel.removeClass('m-search-block__label--move'); }

				});



			};



			var _resetPagination = function () {

				// reset page number to "1" along with min/max

				elements.form.find('[name="page"]').val(1);

				elements.form.find('[name="minpage"]').val(1);

				elements.form.find('[name="maxpage"]').val(1);

			};



			// init

			_bindEvents();



			// ajax

			site.doc.ajaxComplete(function () {

				_bindEvents();

			});



			// load filters

			var filterQuery = 'q=';

			if (location.href.indexOf('?')) {

				filterQuery = location.href.split('?')[1];

			}

			search.loadFilters(elements, filterQuery + '&includeSearchResults=false');



			// check if has jobs

			if (!search.hasResults(elements)) {

				search.showHideNoResults(elements, false);

			}



			// history

			window.onpopstate = function (e) {

				if (e.state) {

					// set page

					elements.form.find('[name="page"]').val(e.state.OriginalQuery.Page);

					// update results

					search.load(elements, '', '', '', false, e.state);

					// update query // TODO

					elements.form.find('[name="q"]').val(e.state.OriginalQuery.Query);

					// scroll

					setTimeout(function () {

						site.scrollTo(elements.noResults.offset().top);

					}, 100);

					// events

					_bindEvents();

				}

			};



			// set up sticky filters



			search.stickyFilters.init();



			// done

			wrapper.addClass('js-replace-search-done');



			// set active flag to true

			search.active = true;



			if (pageLoad) {



				if (elements.searchInput.val() !== '' && !window.location.hash) {



					site.html.add(site.body).animate({ scrollTop: (elements.appliedFilters.parent().offset().top - $('.l-header').height()) }, 500);

					elements.count.focus();



				}



			}



		});



	},



	load: function (elements, data, appendResults, useHistory, altData) {



		var appending = appendResults == 'append';

		var prepending = appendResults == 'prepend';

		var anchorItem = appending ? elements.results.find('[data-results-id]').last() : prepending ? elements.results.find('[data-results-id]').first() : false;



		// clear prev request

		if (search.request != null) {

			search.request.abort();

			search.request = null;

		}



		// disable buttons

		if (appending || prepending) {

			elements.paginationButtons.addClass('loading');

		}

		else {



			search.loading.wait = 0;



			search.loading.timeout = setTimeout(function () {



				if ('performance' in window !== false) {



					search.loading.start = performance.now();

					search.loading.wait = 500; // if the loader is to show, the minimum time it will show for



				}



				elements.loader.show();



			}, 500); // grace period before we might choose to show the loader



			elements.jobs.hide();



		}



		// new request

		if (data == '') {

			// update

			search.update(elements, altData, appendResults, filtering);

			// enable buttons

			if (appending || prepending) {

				elements.paginationButtons.removeClass('loading');



				if (anchorItem.length) {



					if (appending) {



						anchorItem.next('[data-results-id]').find('.m-job-preview__title').focus();



					} else if (prepending) {



						anchorItem.prev('[data-results-id]').find('.m-job-preview__title').focus();



					}



				}

			}

		}

		else {

			search.request = $.ajax({

				url: search.url,

				data: data,

				success: function (response) {



					// reset page

					if (prepending) {

						elements.form.find('[name="page"]').val(parseInt(response.OriginalQuery.Page, 10) + 1);

						data = elements.form.serialize();

					}



					// history

					if (useHistory != null) {

						if (useHistory == 'pushState' && history.pushState) {

							history.pushState(response, '', '?' + data);

						}

						else if (useHistory == 'replaceState' && history.replaceState) {

							history.replaceState(response, '', '?' + data);

						}

					}



					// update

					search.update(elements, response, appendResults);



				},

				error: function (e) {



					if (search.loading.timeout) { clearTimeout(search.loading.timeout); }



					var errorHtml = search.getTemplate(search.templates.error, '#searchErrorResultsTemplate', false);

					elements.noResults.html(errorHtml);



					elements.loader.hide();

					elements.jobs.show();



				},

				complete: function () {

					// enable buttons

					if (appending || prepending) {

						elements.paginationButtons.removeClass('loading');



						if (anchorItem.length) {



							if (appending) {



								anchorItem.next('[data-results-id]').find('.m-job-preview__title').focus();



							} else if (prepending) {



								anchorItem.prev('[data-results-id]').find('.m-job-preview__title').focus();



							}



						}

					}

					// clear request

					search.request = null;

				}

			});

		}



	},



	update: function (elements, data, appendResults) {



		var appending = appendResults == 'append';

		var prepending = appendResults == 'prepend';



		var displayedItems = data.DisplayedItems;

		var totalItems = data.TotalItems;



		// get scroll position

		var oldHeight = site.doc.height();

		var oldScroll = site.win.scrollTop();



		// set has results

		elements.wrapper.attr('data-replace-search-has-jobs', data.Items.length ? true : false);



		// update count

		if (!appending && !prepending) {

			data.TotalItems = site.translations['settingsTranslationXJobsFound'].replace('%total%', totalItems);

			elements.count.html(search.getTemplate(search.templates.count, '#searchResultsCountTemplate', data));

		}



		// hide appropriate elements

		search.showHideNoResults(elements, search.hasResults(elements));



		// update results

		if (data.Items.length) {

			if (!elements.results.length) {

				elements.noResults.html(search.getTemplate(search.templates.resultsList, '#searchResultsListTemplate'));

				elements.results = elements.wrapper.find('[data-replace-search="results"]');

			}

			for (var i = 0; i < data.Items.length; i++) {

				var item = data.Items[i];

				item.MoreDetails = site.translations['settingsTranslationMoreDetails'];

				item.MoreDetailsLabel = site.translations['settingsTranslationMoreDetailsAboutX'].replace('%title%', item.Title);

			}

			var templateData = {

				Jobs: data.Items,

				Page: data.OriginalQuery.Page

			};

			if (appending) {

				elements.results.append(search.getTemplate(search.templates.results, '#jobPreviewTemplate', templateData));

			}

			else if (prepending) {

				elements.results.prepend(search.getTemplate(search.templates.results, '#jobPreviewTemplate', templateData));

			}

			else {

				elements.results.html(search.getTemplate(search.templates.results, '#jobPreviewTemplate', templateData));

			}

		}

		else {

			elements.noResults.html(search.getTemplate(search.templates.noResults, '#searchNoResultsTemplate'));

		}



		// update prev

		if (prepending) {

			// load

			data.ShowPreviousLabel = site.translations['settingsTranslationShowPrevious'];

			data.PrevPage = parseInt(data.OriginalQuery.MinPage, 10);

			elements.paginationPrev.html(search.getTemplate(search.templates.paginationPrev, '#searchResultsPrevTemplate', data));

			// restore scroll pos

			site.doc.scrollTop(oldScroll + site.doc.height() - oldHeight);

		}

		// update next

		data.ShowingTotalItems = site.translations['settingsTranslationShowingXOfYJobs'].replace('%total%', displayedItems).replace('%max%', totalItems);

		data.ShowMoreLabel = site.translations['settingsTranslationShowMore'];

		data.NextPage = parseInt(data.OriginalQuery.MaxPage, 10);

		data.ReturnToFiltersText = site.translations['settingsTranslationReturnToFilters'] || 'Return to filters';

		elements.paginationNext.html(search.getTemplate(search.templates.paginationNext, '#searchResultsNextTemplate', data));



		// update applied filters



		var earlyCareersList = search.getEarlyCareers(data.Filters.FiltersList),

		filtersList = search.getAppliedFilters(data.Filters.FiltersList),

		clearFilters = search.isFiltering(earlyCareersList, filtersList);



		elements.appliedFilters.html(search.getTemplate(search.templates.appliedFilters, '#searchAppliedFiltersTemplate', {

			AppliedFilters: filtersList,

			RemoveText: site.translations["settingsTranslationRemove"],

			ClearFiltersButton: site.translations["settingsTranslationRemoveAllFilters"],

			EarlyCareers: earlyCareersList,

			Title: data.Filters.Title,

			ShowClearFiltersButton: clearFilters,

			FilterResultsBy: site.translations["settingsTranslationFilterResultsBy"]

		}));



		// trigger ajax update

		site.doc.trigger('ajaxComplete');



		// show results

		if (!(appending || prepending)) {



			clearTimeout(search.loading.timeout);



			if ('performance' in window !== false) {



				search.loading.end = performance.now();



				var time_taken = parseInt((search.loading.end - search.loading.start));

				if (time_taken < search.loading.wait) { search.loading.wait = (search.loading.wait - time_taken); }



			}



			setTimeout(function () {



				elements.loader.hide();

				elements.jobs.show();



				search.stickyFilters.allow = false;

				search.stickyFilters.target.removeClass('sticky-filters--in');

				site.html.add(site.body).animate({ scrollTop: (elements.appliedFilters.offset().top - $('.l-header').height()) }, 500);

				setTimeout(function () { search.stickyFilters.allow = true; }, 550);



				if (elements.searchInput.val() !== '') { elements.count.focus(); }



			}, search.loading.wait);



		}



		search.displayCount.show(elements);



	},



	loadFilters: function (elements, query) {

		$.ajax({

			url: search.url,

			data: query,

			success: function (response) {

				// early careers

				response.Filters.FiltersList.Departments.ShowEarlyCareers = true;

				response.Filters.FiltersList.Territories.ShowEarlyCareers = false;

				// update

				elements.filters.html(search.getTemplate(search.templates.filters, '#searchFiltersTemplate', {

					HasSelectedFilters: response.Filters.FiltersSelected,

					FilterGroups: [

						response.Filters.FiltersList.Territories,

						response.Filters.FiltersList.Departments

					],

					EarlyCareers: response.Filters.FiltersList.EarlyCareers,

					ClearText: site.translations["settingsTranslationClear"],

					ApplyText: site.translations["settingsTranslationApply"]

				}));



				// selected



				var earlyCareersList = search.getEarlyCareers(response.Filters.FiltersList),

				filtersList = search.getAppliedFilters(response.Filters.FiltersList),

				clearFilters = search.isFiltering(earlyCareersList, filtersList);



				elements.appliedFilters.html(search.getTemplate(search.templates.appliedFilters, '#searchAppliedFiltersTemplate', {

					AppliedFilters: filtersList,

					ClearFiltersButton: site.translations["settingsTranslationRemoveAllFilters"],

					EarlyCareers: earlyCareersList,

					Title: response.Filters.Title,

					ShowClearFiltersButton: clearFilters,

					FilterResultsBy: site.translations["settingsTranslationFilterResultsBy"]

				}));



				if (elements.searchInput.val() !== '') { elements.count.focus(); }



				search.displayCount.show(elements);



			},

			error: function (e) {

				console.log(e);

			}

		});



		// cache last search term @todo - potentially move this in the future



		search.lastSearchTerm = elements.searchInput.val();



	},



	getAppliedFilters: function (filters) {

		var list = [];

		// departments

		var refParent = filters.Departments.ParentName;

		var refTitle = filters.Departments.Title;

		var children = [];

		for (var i = 0; i < filters.Departments.Items.length; i++) {

			var item = filters.Departments.Items[i];

			for (var j = 0; j < item.Children.length; j++) {

				var child = item.Children[j];

				if (child.Selected) { children.push(child); }

			}

		}

		list.push({

			Ref: refParent,

			Title: refTitle,

			Count: children.length,

			Children: children

		});

		// territories

		refParent = filters.Territories.ParentName;

		refTitle = filters.Territories.Title;

		children = [];

		for (var i = 0; i < filters.Territories.Items.length; i++) {

			var item = filters.Territories.Items[i];

			for (var j = 0; j < item.Children.length; j++) {

				var child = item.Children[j];

				if (child.Selected) { children.push(child); }

			}

		}

		list.push({

			Ref: refParent,

			Title: refTitle,

			Count: children.length,

			Children: children

		});

		return list;

	},



	getEarlyCareers: function (filters) {

		var refParent = filters.EarlyCareers.ParentName;

		for (var i = 0; i < filters.EarlyCareers.Items.length; i++) {

			var item = filters.EarlyCareers.Items[i];

			item.Ref = refParent + '|' + item.Id;

			item.ParentName = refParent;

			return item; // we only ever want one here

		}

	},



	getTemplate: function (templateRef, templateId, data) {

		var template = templateRef;

		if (template == null) {

			var temp = $(templateId);

			if (!temp.length) {

				console.log('Error: cannot find template ' + templateId);

				return;

			}

			template = Hogan.compile(temp.html());

			templateRef = template;

		}

		return template.render(data);

	},



	isFiltering: function (earlyCareersList, filtersList) {



		if (earlyCareersList.Selected) { return true; }

		for (var i = 0; i < filtersList.length; i++) { if (filtersList[i].Count) { return true; } }



		return false;



	},



	hasResults: function (elements) {

		return elements.wrapper.attr('data-replace-search-has-jobs').toLowerCase() == 'true' ? true : false;

	},



	showHideNoResults: function (elements, show) {

		var e = elements.header

			.add(elements.paginationPrev)

			.add(elements.paginationNext)

			.add(elements.sort);

		show ? e.removeClass('m-jobs-list__header--hidden') : e.addClass('m-jobs-list__header--hidden');

	},



	collapseFilters: function (elements) {

		elements.wrapper.find('.js-accordion-title.expanded').click();

	},



	displayCount: {



		endpoint: '/' + site.html.attr('lang') + '/api/search/jobs-count/',



		start: 0,



		end: 0,



		wait: 0,



		timeout: null,



		request: null,



		show: function (elements) {



			search.displayCount.wait = 0;

			clearTimeout(search.displayCount.timeout);



			search.displayCount.timeout = setTimeout(function () {



				if ('performance' in window !== false) {



					search.displayCount.start = performance.now();

					search.displayCount.wait = 500; // if the loader is to show, the minimum time it will show for



				}



				$('.js-replace-search-job-count').hide();

				$('.js-replace-search-job-loader').show();



			}, 500); // grace period before we might choose to show the loader



			// cache serialized form and the filters overlay



			var seralizedForm = elements.form.serialize(),

			filtersOverlay = $('.mfp-filters-overlay');



			// if filters overlay exists, add the form elements inside to the serialized form string



			if (filtersOverlay.length) { seralizedForm += '&' + filtersOverlay.find(':input').serialize(); }



			// if there is an existing request, abort it



			if (search.displayCount.request != null) {



				search.displayCount.request.abort();

				search.displayCount.request = null;



			}



			// make request



			search.displayCount.request = $.ajax({

				url: search.displayCount.endpoint,

				data: seralizedForm,

				success: function (response) {



					clearTimeout(search.displayCount.timeout);



					if ('performance' in window !== false) {



						search.displayCount.end = performance.now();



						var time_taken = parseInt((search.displayCount.end - search.displayCount.start));

						if (time_taken < search.displayCount.wait) { search.displayCount.wait = (search.displayCount.wait - time_taken); }



					}



					setTimeout(function () {



						var text = site.translations['settingsTranslationXJobsFoundShort'].replace('%total%', response.TotalItems);

						$('.js-replace-search-job-count').show().html(text);

						$('.js-replace-search-job-loader').hide();



					}, search.loading.wait);



				},

				error: function (e) {



					console.log(e);



				},

				complete: function () {

					

					search.displayCount.request = null;



				}

			});



		}



	},



	state: {



		form: $('.js-replace-search form[data-replace-search="form"]:first'),



		should_restore: true,



		data: false,



		count: false,



		save: function (form) {



			search.state.data = search.state.form.formstate();

			search.state.count = $('.js-replace-search-job-count').html();



		},



		restore: function (form) {



			if (search.state.should_restore) {



				search.state.form.formstate(search.state.data);

				$('.js-replace-search-job-count').html(search.state.count);



			}



		}



	},



	stickyFilters: {



		target: null,



		init: function () {



			var stickyElement = document.querySelector('[data-sticky-filters]');

			search.stickyFilters.target = $('[data-sticky-filters]');



			if (!stickyElement || !utils.supportsSticky()) return;



			stickyElement.insertAdjacentHTML('beforebegin', '<div data-sticky-filters-off></div>');

			var stickyOffElement = document.querySelector('[data-sticky-filters-off]');



			var allowAnimation = false;

			var visibleTimeout;



			// sticky filters



			var lastStickyPosition;



			var stickyObserver = new IntersectionObserver(function (entries) {



				var y = entries[0].boundingClientRect.y;

				var down = lastStickyPosition !== undefined ? lastStickyPosition > y : true;

				lastStickyPosition = y;



				if (down) {



					if (y < 0) { // has scrolled by



						stickyElement.classList.add('sticky-filters--stuck');

						allowAnimation = true;



					}



				}



			});



			stickyObserver.observe(stickyElement);



			// sticky off anchor



			var lastStickyOffPosition;



			var stickyOffObserver = new IntersectionObserver(function (entries) {



				var y = entries[0].boundingClientRect.y;

				var down = lastStickyOffPosition !== undefined ? lastStickyOffPosition > y : true;

				lastStickyOffPosition = y;



				if (!down) {



					allowAnimation = false;

					clearTimeout(visibleTimeout);



					stickyElement.classList.remove('sticky-filters--stuck');

					stickyElement.classList.remove('sticky-filters--can-animate');

					stickyElement.classList.remove('sticky-filters--visible');



				}



			});



			stickyOffObserver.observe(stickyOffElement);



			// window scroll event for animations



			var position = window.scrollY;



			document.addEventListener('scroll', function (e) {



				var scroll = window.scrollY;



				if (allowAnimation) {



					if (scroll > position) {



						stickyElement.classList.remove('sticky-filters--visible');



					} else {



						stickyElement.classList.add('sticky-filters--can-animate');

						visibleTimeout = setTimeout(function () { stickyElement.classList.add('sticky-filters--visible'); }, 10);



					}



				}



				position = scroll;



			});



		}



	}



};



$(function () {

	search.preInit();

	site.doc.ajaxComplete(function () {

		search.init(false);

	});

});